import { DataPostAdapter } from "../../adapter";
export default async function DataPostService(payload) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('bmsf.dev.bpimsapps.com');
    const isUAT = url.includes('bmsf.uat.bpimsapps.com');
    const isProd = url.includes('projectbringme.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
            ? 'https://partners-api.dev.bpimsapps.com/survey/create'
            : isUAT
            ? 'https://partners-api.uat.bpimsapps.com/survey/create'
            : isProd
            ? `https://partners-api.bpimsapps.com/survey/create` : `https://partners-api.bpimsapps.com/survey/create`;

    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/survey/create';

    const result = await DataPostAdapter(endpoint, payload);
    return result;
}
